import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import Button from 'components/Button';
import './offlineOverlay.css';

class OfflineOverlay extends PureComponent {
  state = {
    retryLoading: false
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  retryAnimation = () => {
    clearTimeout(this.timeout);
    this.setState({ retryLoading: true });
    this.timeout = setTimeout(() => {
      this.setState({ retryLoading: false });
    }, this.props.retryDelay);
  };

  render() {
    const { retryLoading } = this.state;
    const { name } = this.props;

    return (
      <div className="offline-overlay">
        <div className={cc(['offline-overlay__container', { 'animate--loading': retryLoading }])}>
          <h1 className="hero">:(</h1>
          <h4>{retryLoading ? 'Connecting...' : `Can't connect to ${name}`}</h4>
          <p>
            You will be reconnected automatically <wbr />
            as soon as possible
          </p>
          <Button
            name="retryConnection"
            id="offlineOverlay-retryConnection"
            buttonText={retryLoading ? 'Retrying...' : 'Retry'}
            className="white"
            onClick={this.retryAnimation}
          />
        </div>
      </div>
    );
  }
}

OfflineOverlay.propTypes = {
  name: PropTypes.string.isRequired,
  retryDelay: PropTypes.number
};

OfflineOverlay.defaultProps = {
  retryDelay: 3200
};

export default OfflineOverlay;
